<template>
  <PageContainer>
    <View direction="column" gap="sm">
      <View direction="column" gap="sm">
        <PageBackNav
          :teleport-slot-id="headerTeleportSlot"
          :desktop-back-title="'Back to Renter profile'"
          @back-nav="goBack(renterProfileRoute(propertyId, renterId))"
        />

        <View gap="sm" direction="column-reverse" class="blocks-wrap">
          <RenterProfileBundle />
          <RenterApplicationVerdict />
        </View>
      </View>

      <View />
    </View>
  </PageContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { PageBackNav, PageContainer, View } from '@tallo/design-system';
import { renterProfileRoute, useNavigation } from '@tallo/investor/navigation';

import { headerTeleportSlot } from '../root/header-teleport-slot.const';
import RenterApplicationVerdict from './components/renter-application-verdict.vue';
import RenterProfileBundle from './components/renter-profile-bundle.vue';

const route = useRoute();
const renterId = ref(route.params.renterId as string);
const propertyId = ref(route.params.propertyId as string);
const { goBack } = useNavigation();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

@include screen-min-lg {
  .blocks-wrap {
    flex-direction: row;
  }
}
</style>
